import { useState } from 'react';
import { FaYoutube, FaInstagram, FaTiktok, FaFacebookF, FaLinkedin } from 'react-icons/fa';
import styles from './SocialLinks.module.css';

const socialLinks = [
  { icon: <FaYoutube />, url: 'https://www.youtube.com/@samanthashenolguin', label: 'YouTube' },
  { icon: <FaInstagram />, url: 'https://www.instagram.com/samanthashenolguin', label: 'Instagram' },
  { icon: <FaTiktok />, url: 'https://www.tiktok.com/@samanthashenolguin', label: 'TikTok' },
  { icon: <FaFacebookF />, url: 'https://www.facebook.com/samanthashenogluin', label: 'Facebook' },
  { icon: <FaLinkedin />, url: 'https://www.linkedin.com/in/samanthashenolguin/', label: 'LinkedIn' },
];

const SocialLinks = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div className={styles.socialLinks}>
      {socialLinks.map((link, index) => (
        <a
          key={index}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.icon} ${
            hoveredIndex !== null && hoveredIndex !== index ? styles.otherIcons : ''
          }`}
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
          aria-label={link.label}
        >
          {link.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;